import { EigentumanteilVersionDetailEntryMeta } from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';

export class EigentumanteilVersionVm {
  constructor(
    public object: EigentumanteilVersionDetailEntryMeta,
    private translateService: TranslateService
  ) {}

  get quoteValue(): string {
    let res: string = '';
    if (this.displayQuote()) {
      res = this.object.quote.zaehler + '/' + this.object.quote.nenner;
    } else if (this.object.quoteUnbekannt) {
      res = this.translateService.instant('UNBEKANNT');
    } else if (this.object.quoteAlsText) {
      res = this.object.quoteAlsText;
    }
    return res;
  }

  private displayQuote(): boolean {
    if (!this.object.quote) {
      return false;
    }
    return !(this.object.quote.zaehler === 0 && this.object.quote.nenner === 0);
  }
}
